import React from "react";
import PropTypes from "prop-types";

const NewHireAwardIcon = ({ fill, width, height, boxShadow }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 84 84"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M42 0H84V42V84L42 71.4L0 84V42V0H42Z" fill={fill} />
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="84"
        height="84"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M84 0H42H0V21H84V0ZM84 52.5V84H0V52.5H42H84Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M42 62.3363L75.6 72.4163V8.4H8.4V72.4163L42 62.3363ZM5.25 76.65V5.25H78.75V76.65L42 65.625L5.25 76.65Z"
          fill="white"
        />
      </g>
      <ellipse cx="77.6996" cy="30.45" rx="2.1" ry="2.1" fill="white" />
      <ellipse cx="77.6996" cy="43.05" rx="2.1" ry="2.1" fill="white" />
      <ellipse cx="6.3002" cy="30.45" rx="2.1" ry="2.1" fill="white" />
      <ellipse cx="6.3" cy="26.25" rx="1.05" ry="1.05" fill="white" />
      <ellipse cx="6.3" cy="47.25" rx="1.05" ry="1.05" fill="white" />
      <circle cx="77.6994" cy="26.25" r="1.05" fill="white" />
      <circle cx="77.6994" cy="47.25" r="1.05" fill="white" />
      <ellipse cx="6.3002" cy="43.05" rx="2.1" ry="2.1" fill="white" />
      <path
        d="M6.2998 31.5L10.2373 36.5806L6.2998 42L2.3623 36.5806L6.2998 31.5Z"
        fill="white"
      />
      <path
        d="M77.7002 31.5L81.6377 36.5806L77.7002 42L73.7627 36.5806L77.7002 31.5Z"
        fill="white"
      />
      <path
        d="M21.0596 26.2717C21.0596 26.2717 22.7328 26.2717 23.578 26.2717C26.7711 26.2717 26.7711 28.9364 26.7711 28.9364V43.9292C26.7711 43.9292 26.771 46.2621 23.578 46.2621C20.385 46.2621 21.0595 46.2621 21.0595 46.2621L21.0596 26.2717Z"
        fill="white"
      />
      <path
        opacity="0.75"
        d="M63.8956 26.2717C63.8956 26.2717 62.2223 26.2717 61.3771 26.2717C58.184 26.2717 58.184 28.9364 58.184 28.9364V43.9292C58.184 43.9292 58.1841 46.2621 61.3771 46.2621C64.5701 46.2621 63.8956 46.2621 63.8956 46.2621L63.8956 26.2717Z"
        fill="white"
      />
      <path
        opacity="0.75"
        d="M28.9921 43.2487H26.6123V28.9698H38.8502C45.974 32.9888 48.3002 37.8005 53.0252 43.0505C54.7157 44.9288 53.5502 47.2505 49.3502 44.6255C51.9752 47.2505 48.3002 48.3005 45.6752 45.6755C48.3002 48.8255 45.1502 48.8255 42.5252 47.2505C44.1002 48.5105 43.615 49.4388 42.0002 49.3505C41.2274 49.3082 38.31 49.1653 37.8002 48.8255L28.9921 43.2487Z"
        fill="white"
      />
      <ellipse
        cx="29.6616"
        cy="43.3503"
        rx="1.05"
        ry="1.575"
        transform="rotate(25.7588 29.6616 43.3503)"
        fill="white"
      />
      <ellipse
        cx="31.7584"
        cy="44.5872"
        rx="1.575"
        ry="2.1"
        transform="rotate(27.0675 31.7584 44.5872)"
        fill="white"
      />
      <ellipse
        cx="34.3356"
        cy="46.2006"
        rx="1.575"
        ry="2.1"
        transform="rotate(26.4832 34.3356 46.2006)"
        fill="white"
      />
      <ellipse
        cx="36.8417"
        cy="47.7515"
        rx="1.575"
        ry="2.1"
        transform="rotate(29.11 36.8417 47.7515)"
        fill="white"
      />
      <path
        d="M48.9032 26.2692C52.7903 29.1844 55.8048 28.6484 58.1846 28.6484V43.0506L52.5 42.5256C49.8749 41.4746 48.2999 38.8492 45.6749 34.1246C43.5749 33.0756 42.5249 32.0246 41.9999 30.9749C39.8999 33.5996 39.3749 34.3349 37.2749 35.1749C34.6499 36.2249 33.9508 33.5996 34.6499 32.5506C36.3298 30.03 36.2249 28.6484 38.8499 26.2687C43.0499 24.6755 45.7301 23.8894 48.9032 26.2692Z"
        fill="white"
      />
    </svg>
  );
};

NewHireAwardIcon.propTypes = {
  /**
   * The color of the award icon
   * Can be any CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
   */
  fill: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  boxShadow: PropTypes.bool
};

NewHireAwardIcon.defaultProps = {
  width: "75%",
  height: 114,
  boxShadow: true
};

export default NewHireAwardIcon;
